import { useLocation } from 'react-router';

/** Same-origin paths only - never bounce to a URL someone put in a link. */
const isSafeTarget = (target: string | null): target is string =>
  Boolean(target?.startsWith('/') && !target.startsWith('//'));

/** Where to go after signing in: the page that sent us to /sign-in, or home. */
export function useRedirectTarget(): string {
  const target = new URLSearchParams(useLocation().search).get('redirect_url');
  return isSafeTarget(target) ? target : '/';
}

/** `path` carrying the redirect target along, so the next auth screen keeps it. */
export function withRedirect(path: string, target: string): string {
  if (target === '/') return path;
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}redirect_url=${encodeURIComponent(target)}`;
}

/** `withRedirect` for the current screen's target. */
export function useWithRedirect(): (path: string) => string {
  const target = useRedirectTarget();
  return (path) => withRedirect(path, target);
}
